/* eslint-env node */
require('./src/styles/global.css')
